import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import artworkNotFound from 'portal/assets/NotFound/artworkNotFound.svg'

import { ColourButton } from 'portal/lib/primitives'
import { PageContainer } from 'portal/pages/PageContainer'

export const NotFound = (): JSX.Element => {
  const navigate = useNavigate()

  return (
    <Container limitWidth>
      <Image />

      <Button id="notFoundBackBtn" onClick={() => navigate(-1)}>
        Go Back
      </Button>
    </Container>
  )
}

const Container = styled(PageContainer)`
  align-items: center;
  justify-content: center;
`

const Image = styled.img.attrs(() => ({
  src: artworkNotFound
}))`
  width: 80%;
  max-width: 40rem;
  height: auto;
`

const Button = styled(ColourButton.Action)`
  margin-top: 5rem;

  min-width: 4rem;
  width: 25%;
  max-width: 15rem;
`
